import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import {
  AnalyticsFetchThreadsResponse,
  AnalyticsFetchThreadsSentimentType,
  AnalyticsFetchThreadsVectorType,
} from 'src/services/__generated__/api'
import { UseGetNeutralSentimentAnalysisThreadsQueryParams } from './interfaces/useGetNeutralSentimentAnalysisThreadsQuery.interface'

const getNeutralSentimentAnalysisThreads = async (
  campaign?: string,
  keyword?: string,
  lastDate?: string,
  limit?: number,
  selectedKeywords?: string,
  selectedSources?: string,
  fromDate?: string,
  toDate?: string,
  languages?: string,
  mentionFormat?: string,
  mentionType?: string,
  search?: string
): Promise<AnalyticsFetchThreadsResponse | null> => {
  if (!lastDate || !limit) {
    return null
  }

  const { data } = await AnalyticsApi.v1Private.analyticsFetchThreadsList({
    campaign,
    fromDate,
    keyword,
    languages,
    lastDate,
    limit,
    mentionFormat,
    mentionType,
    search,
    selectedKeywords,
    selectedSources,
    sentiment: AnalyticsFetchThreadsSentimentType.NEU,
    toDate,
    vector: AnalyticsFetchThreadsVectorType.Desc,
  })

  return data ?? null
}

export const useGetNeutralSentimentAnalysisThreadsQuery = (
  params: UseGetNeutralSentimentAnalysisThreadsQueryParams
) => {
  return useQuery({
    queryFn: () =>
      getNeutralSentimentAnalysisThreads(
        params.campaign,
        params.keyword,
        params.lastDate,
        params.limit,
        params.selectedKeywords,
        params.selectedSources,
        params.fromDate,
        params.toDate,
        params.selectedLanguages,
        params.selectedMentionFormats,
        params.selectedMentionTypes,
        params.search
      ),
    queryKey: [
      QueryKey.GET_NEU_SENTIMENT_ANALYSIS_THREADS,
      ...Object.values(params),
    ],
    refetchInterval: Infinity,
  })
}
